import { EventEmitter, Component, Input, Output, OnInit } from '@angular/core';
import { NotesService } from '../../../shared/services/notes.service';
import { Subscription } from 'rxjs';
import { IfStmt } from '@angular/compiler';

@Component({
    selector: 'pandora-aside',
    templateUrl: './pandora-aside.component.html',
    styleUrls: [ './pandora-aside.component.scss' ]
})
export class PandoraAsideComponent implements OnInit {

    // Should the sidebar be displayed right now (user toggled it on)
    @Input() isAsideOpen: Boolean = false;
    // Is the sidebar allowed to be toggled open/closed
    @Input() isToggleAvailable: Boolean = false;
    // Should a toggle button appear on the right side when the sidebar is closed
    @Input() isToggleButtonExists: Boolean = false;
    // Main heading (as well as the label of the toggle button)
    @Input() title: String = 'Filter';
    // Text within sidebar for the 'hide' button
    @Input() closeText: String = 'Hide';
    // Should the sidebar's 'hide' button also display a little '>'
    @Input() closeChevron: Boolean = true;
    @Input() subTitle: Date;

    constructor(private notesService: NotesService) {
    }

    ngOnInit() {
    }

    toggleAside(value, $event): void {
        if (this.isToggleAvailable) {
            this.isAsideOpen = value;
        }
        if ($event && $event.target.innerText === 'Close') {
            this.notesService.sendCloseNoteEvent();
        }
    }

}
